import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1caaecc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ly_record" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "arrow-right" }, null, -1))

import { onMounted, onUnmounted, ref } from "vue";
import { rootStore } from "@/services/RootStore";
import { useFontSelector } from "@/services/LocalizeService";
import eventService, { SessionAction } from "@/services/EventService";
import SessionService, { MenuType } from "@/services/SessionService";
import HistoryModel from "@/models/HistoryModel";
import UserService from "@/services/UserService";


export default /*#__PURE__*/_defineComponent({
  __name: 'PredictionItem',
  props: {
  word: String,
  history: HistoryModel
},
  setup(__props) {

const jpFont = useFontSelector().getFont(true);
const isChecked = ref(false);
const userLocale = UserService.getLanguageSetting();

// コンポーネントのpropsを定義します
// Remove the unused assignment of 'props' variable
const props = __props;

onMounted(() => {
  eventService.on(SessionAction.SelectAll, onSelectAll);
  eventService.on(SessionAction.ChangeEditMode, onModeChanged);
  eventService.on(SessionAction.Delete, onDelete);
  eventService.addRef(SessionAction.ItemChecked, isChecked);
});

onUnmounted(() => {
  eventService.off(SessionAction.SelectAll, onSelectAll);
  eventService.off(SessionAction.ChangeEditMode, onModeChanged);
  eventService.off(SessionAction.Delete, onDelete);
  eventService.removeRef(SessionAction.ItemChecked, isChecked);
});

function onModeChanged() {
  isChecked.value = false;
}

async function onDelete() {
  if (isChecked.value) {
    if (SessionService.GetNowMenuType() == MenuType.history) {
      const leftHistoriesCount = await props.history?.removeHistory();

      if (leftHistoriesCount == 0) {
        rootStore.ChangeEditMode(false);
      }
    } else if (SessionService.GetNowMenuType() == MenuType.bookmark) {
      const leftBookmarkCount = await props.history?.removeBookmark();
      if (leftBookmarkCount == 0) {
        rootStore.ChangeEditMode(false);
      }
    }
  }
}
function onSelectAll() {
  isChecked.value = true;
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    (_unref(rootStore).sessionState.isEditMode)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: `checkbox-${__props.word}`,
          class: "ly_checkbox-group"
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "record-checkbox",
            id: `checkbox-${__props.word}`,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isChecked).value = $event))
          }, null, 8, _hoisted_3), [
            [_vModelCheckbox, isChecked.value]
          ]),
          _hoisted_4,
          _createElementVNode("span", {
            class: "bl_text",
            style: _normalizeStyle({ fontFamily: _unref(jpFont) })
          }, _toDisplayString(__props.word), 5)
        ], 8, _hoisted_2))
      : (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: { name: 'word-detail', params: { word: __props.word, lang: _unref(userLocale) } },
          class: "record-content"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: "bl_text",
              style: _normalizeStyle({ fontFamily: _unref(jpFont) })
            }, _toDisplayString(__props.word), 5),
            _hoisted_5
          ]),
          _: 1
        }, 8, ["to"]))
  ]))
}
}

})